module.exports = __webpack_public_path__ + "static/s5-2-cleaning-d-c7f125419434929eab0e94d25b26704a.jpg";